__turbopack_context__.v({
  "banner": "info-banner-module-scss-module__Ze6Iza__banner",
  "banner-bg-highlight-moss-strong": "info-banner-module-scss-module__Ze6Iza__banner-bg-highlight-moss-strong",
  "banner-bg-info": "info-banner-module-scss-module__Ze6Iza__banner-bg-info",
  "banner-bg-success": "info-banner-module-scss-module__Ze6Iza__banner-bg-success",
  "close-button": "info-banner-module-scss-module__Ze6Iza__close-button",
  "content": "info-banner-module-scss-module__Ze6Iza__content",
  "placeholder": "info-banner-module-scss-module__Ze6Iza__placeholder",
});
